var cov_w433papgl = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Table/TreeExpand.tsx",
      hash = "e206cf00df03784b15cf33fd8c8eae014534018c",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Table/TreeExpand.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 34
        },
        end: {
          line: 8,
          column: 36
        }
      },
      "1": {
        start: {
          line: 14,
          column: 21
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "2": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 144,
          column: 3
        }
      },
      "3": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 18
        }
      },
      "4": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 29,
          column: 7
        }
      },
      "5": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 31,
          column: 62
        }
      },
      "6": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 35,
          column: 34
        }
      },
      "7": {
        start: {
          line: 39,
          column: 26
        },
        end: {
          line: 39,
          column: 36
        }
      },
      "8": {
        start: {
          line: 40,
          column: 6
        },
        end: {
          line: 42,
          column: 7
        }
      },
      "9": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 83
        }
      },
      "10": {
        start: {
          line: 41,
          column: 55
        },
        end: {
          line: 41,
          column: 83
        }
      },
      "11": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 38
        }
      },
      "12": {
        start: {
          line: 47,
          column: 33
        },
        end: {
          line: 47,
          column: 43
        }
      },
      "13": {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 55
        }
      },
      "14": {
        start: {
          line: 48,
          column: 27
        },
        end: {
          line: 48,
          column: 55
        }
      },
      "15": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 55
        }
      },
      "16": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 56,
          column: 42
        }
      },
      "17": {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 54,
          column: 26
        }
      },
      "18": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 55,
          column: 18
        }
      },
      "19": {
        start: {
          line: 77,
          column: 48
        },
        end: {
          line: 77,
          column: 58
        }
      },
      "20": {
        start: {
          line: 78,
          column: 25
        },
        end: {
          line: 78,
          column: 45
        }
      },
      "21": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 79,
          column: 34
        }
      },
      "22": {
        start: {
          line: 80,
          column: 6
        },
        end: {
          line: 80,
          column: 44
        }
      },
      "23": {
        start: {
          line: 80,
          column: 33
        },
        end: {
          line: 80,
          column: 44
        }
      },
      "24": {
        start: {
          line: 82,
          column: 30
        },
        end: {
          line: 82,
          column: 39
        }
      },
      "25": {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 73
        }
      },
      "26": {
        start: {
          line: 83,
          column: 41
        },
        end: {
          line: 83,
          column: 72
        }
      },
      "27": {
        start: {
          line: 84,
          column: 24
        },
        end: {
          line: 84,
          column: 56
        }
      },
      "28": {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 102,
          column: 8
        }
      },
      "29": {
        start: {
          line: 86,
          column: 21
        },
        end: {
          line: 86,
          column: 26
        }
      },
      "30": {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 101,
          column: 9
        }
      },
      "31": {
        start: {
          line: 88,
          column: 10
        },
        end: {
          line: 88,
          column: 47
        }
      },
      "32": {
        start: {
          line: 88,
          column: 42
        },
        end: {
          line: 88,
          column: 47
        }
      },
      "33": {
        start: {
          line: 89,
          column: 23
        },
        end: {
          line: 89,
          column: 44
        }
      },
      "34": {
        start: {
          line: 90,
          column: 22
        },
        end: {
          line: 90,
          column: 45
        }
      },
      "35": {
        start: {
          line: 91,
          column: 30
        },
        end: {
          line: 91,
          column: 60
        }
      },
      "36": {
        start: {
          line: 92,
          column: 27
        },
        end: {
          line: 92,
          column: 76
        }
      },
      "37": {
        start: {
          line: 93,
          column: 10
        },
        end: {
          line: 100,
          column: 11
        }
      },
      "38": {
        start: {
          line: 94,
          column: 12
        },
        end: {
          line: 96,
          column: 14
        }
      },
      "39": {
        start: {
          line: 95,
          column: 14
        },
        end: {
          line: 95,
          column: 74
        }
      },
      "40": {
        start: {
          line: 97,
          column: 12
        },
        end: {
          line: 97,
          column: 56
        }
      },
      "41": {
        start: {
          line: 98,
          column: 12
        },
        end: {
          line: 98,
          column: 26
        }
      },
      "42": {
        start: {
          line: 99,
          column: 12
        },
        end: {
          line: 99,
          column: 39
        }
      },
      "43": {
        start: {
          line: 106,
          column: 55
        },
        end: {
          line: 106,
          column: 65
        }
      },
      "44": {
        start: {
          line: 107,
          column: 25
        },
        end: {
          line: 107,
          column: 45
        }
      },
      "45": {
        start: {
          line: 108,
          column: 18
        },
        end: {
          line: 108,
          column: 45
        }
      },
      "46": {
        start: {
          line: 109,
          column: 26
        },
        end: {
          line: 112,
          column: 8
        }
      },
      "47": {
        start: {
          line: 111,
          column: 8
        },
        end: {
          line: 111,
          column: 70
        }
      },
      "48": {
        start: {
          line: 113,
          column: 6
        },
        end: {
          line: 116,
          column: 7
        }
      },
      "49": {
        start: {
          line: 114,
          column: 8
        },
        end: {
          line: 114,
          column: 82
        }
      },
      "50": {
        start: {
          line: 115,
          column: 8
        },
        end: {
          line: 115,
          column: 14
        }
      },
      "51": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 33
        }
      },
      "52": {
        start: {
          line: 118,
          column: 6
        },
        end: {
          line: 120,
          column: 8
        }
      },
      "53": {
        start: {
          line: 124,
          column: 34
        },
        end: {
          line: 124,
          column: 44
        }
      },
      "54": {
        start: {
          line: 125,
          column: 25
        },
        end: {
          line: 125,
          column: 45
        }
      },
      "55": {
        start: {
          line: 126,
          column: 19
        },
        end: {
          line: 126,
          column: 39
        }
      },
      "56": {
        start: {
          line: 128,
          column: 8
        },
        end: {
          line: 129,
          column: 9
        }
      },
      "57": {
        start: {
          line: 128,
          column: 25
        },
        end: {
          line: 128,
          column: 108
        }
      },
      "58": {
        start: {
          line: 130,
          column: 25
        },
        end: {
          line: 130,
          column: 45
        }
      },
      "59": {
        start: {
          line: 131,
          column: 6
        },
        end: {
          line: 142,
          column: 7
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 16
          },
          end: {
            line: 17,
            column: 17
          }
        },
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 144,
            column: 3
          }
        },
        line: 18
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        },
        loc: {
          start: {
            line: 25,
            column: 82
          },
          end: {
            line: 32,
            column: 5
          }
        },
        line: 25
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        },
        loc: {
          start: {
            line: 34,
            column: 25
          },
          end: {
            line: 36,
            column: 5
          }
        },
        line: 34
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        },
        loc: {
          start: {
            line: 38,
            column: 20
          },
          end: {
            line: 44,
            column: 5
          }
        },
        line: 38
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 5
          }
        },
        loc: {
          start: {
            line: 46,
            column: 20
          },
          end: {
            line: 50,
            column: 5
          }
        },
        line: 46
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        loc: {
          start: {
            line: 52,
            column: 48
          },
          end: {
            line: 57,
            column: 5
          }
        },
        line: 52
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 53,
            column: 24
          },
          end: {
            line: 53,
            column: 25
          }
        },
        loc: {
          start: {
            line: 53,
            column: 38
          },
          end: {
            line: 56,
            column: 7
          }
        },
        line: 53
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        },
        loc: {
          start: {
            line: 76,
            column: 20
          },
          end: {
            line: 103,
            column: 5
          }
        },
        line: 76
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 83,
            column: 25
          },
          end: {
            line: 83,
            column: 26
          }
        },
        loc: {
          start: {
            line: 83,
            column: 41
          },
          end: {
            line: 83,
            column: 72
          }
        },
        line: 83
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 85,
            column: 30
          },
          end: {
            line: 85,
            column: 31
          }
        },
        loc: {
          start: {
            line: 85,
            column: 39
          },
          end: {
            line: 102,
            column: 7
          }
        },
        line: 85
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 94,
            column: 29
          },
          end: {
            line: 94,
            column: 30
          }
        },
        loc: {
          start: {
            line: 94,
            column: 38
          },
          end: {
            line: 96,
            column: 13
          }
        },
        line: 94
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        },
        loc: {
          start: {
            line: 105,
            column: 52
          },
          end: {
            line: 121,
            column: 5
          }
        },
        line: 105
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 109,
            column: 44
          },
          end: {
            line: 109,
            column: 45
          }
        },
        loc: {
          start: {
            line: 109,
            column: 53
          },
          end: {
            line: 112,
            column: 7
          }
        },
        line: 109
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 123,
            column: 5
          }
        },
        loc: {
          start: {
            line: 123,
            column: 13
          },
          end: {
            line: 143,
            column: 5
          }
        },
        line: 123
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 128,
            column: 20
          },
          end: {
            line: 128,
            column: 21
          }
        },
        loc: {
          start: {
            line: 128,
            column: 25
          },
          end: {
            line: 128,
            column: 108
          }
        },
        line: 128
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 83
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 83
          }
        }, {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 83
          }
        }],
        line: 41
      },
      "1": {
        loc: {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 55
          }
        }, {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 55
          }
        }],
        line: 48
      },
      "2": {
        loc: {
          start: {
            line: 80,
            column: 6
          },
          end: {
            line: 80,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 6
          },
          end: {
            line: 80,
            column: 44
          }
        }, {
          start: {
            line: 80,
            column: 6
          },
          end: {
            line: 80,
            column: 44
          }
        }],
        line: 80
      },
      "3": {
        loc: {
          start: {
            line: 88,
            column: 10
          },
          end: {
            line: 88,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 10
          },
          end: {
            line: 88,
            column: 47
          }
        }, {
          start: {
            line: 88,
            column: 10
          },
          end: {
            line: 88,
            column: 47
          }
        }],
        line: 88
      },
      "4": {
        loc: {
          start: {
            line: 91,
            column: 30
          },
          end: {
            line: 91,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 30
          },
          end: {
            line: 91,
            column: 55
          }
        }, {
          start: {
            line: 91,
            column: 59
          },
          end: {
            line: 91,
            column: 60
          }
        }],
        line: 91
      },
      "5": {
        loc: {
          start: {
            line: 93,
            column: 10
          },
          end: {
            line: 100,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 10
          },
          end: {
            line: 100,
            column: 11
          }
        }, {
          start: {
            line: 93,
            column: 10
          },
          end: {
            line: 100,
            column: 11
          }
        }],
        line: 93
      },
      "6": {
        loc: {
          start: {
            line: 93,
            column: 14
          },
          end: {
            line: 93,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 93,
            column: 14
          },
          end: {
            line: 93,
            column: 38
          }
        }, {
          start: {
            line: 93,
            column: 42
          },
          end: {
            line: 93,
            column: 50
          }
        }],
        line: 93
      },
      "7": {
        loc: {
          start: {
            line: 111,
            column: 8
          },
          end: {
            line: 111,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 111,
            column: 30
          },
          end: {
            line: 111,
            column: 47
          }
        }, {
          start: {
            line: 111,
            column: 50
          },
          end: {
            line: 111,
            column: 70
          }
        }],
        line: 111
      },
      "8": {
        loc: {
          start: {
            line: 113,
            column: 6
          },
          end: {
            line: 116,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 6
          },
          end: {
            line: 116,
            column: 7
          }
        }, {
          start: {
            line: 113,
            column: 6
          },
          end: {
            line: 116,
            column: 7
          }
        }],
        line: 113
      },
      "9": {
        loc: {
          start: {
            line: 113,
            column: 10
          },
          end: {
            line: 113,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 113,
            column: 10
          },
          end: {
            line: 113,
            column: 24
          }
        }, {
          start: {
            line: 113,
            column: 28
          },
          end: {
            line: 113,
            column: 40
          }
        }],
        line: 113
      },
      "10": {
        loc: {
          start: {
            line: 128,
            column: 25
          },
          end: {
            line: 128,
            column: 108
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 128,
            column: 25
          },
          end: {
            line: 128,
            column: 26
          }
        }, {
          start: {
            line: 128,
            column: 30
          },
          end: {
            line: 128,
            column: 49
          }
        }, {
          start: {
            line: 128,
            column: 53
          },
          end: {
            line: 128,
            column: 108
          }
        }],
        line: 128
      },
      "11": {
        loc: {
          start: {
            line: 134,
            column: 27
          },
          end: {
            line: 134,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 27
          },
          end: {
            line: 134,
            column: 47
          }
        }, {
          start: {
            line: 134,
            column: 51
          },
          end: {
            line: 134,
            column: 77
          }
        }],
        line: 134
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Table/TreeExpand.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import { getKey } from '../utils/uid';
import { keysToArray } from '../utils/transform';
var TREE_TABLE_DEFAULT_INDENT = (cov_w433papgl.s[0]++, 15);
var defaultProps = (cov_w433papgl.s[1]++, {
  defaultTreeExpandKeys: []
});
export default (function (WrappedComponent) {
  var _class, _temp;

  cov_w433papgl.f[0]++;
  cov_w433papgl.s[2]++;
  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(TreeExpand, _React$Component);

    var _super = _createSuper2(TreeExpand);

    function TreeExpand(props) {
      var _this;

      _classCallCheck(this, TreeExpand);

      cov_w433papgl.f[1]++;
      cov_w433papgl.s[3]++;
      _this = _super.call(this, props);
      _this.changedByExpand = void 0;
      _this.expandLevel = void 0;
      cov_w433papgl.s[4]++;
      _this.state = {
        expandKeys: TreeExpand.getMapFromArray(props.defaultTreeExpandKeys)
      };
      cov_w433papgl.s[5]++;
      _this.handleTreeExpand = _this.handleTreeExpand.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(TreeExpand, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        cov_w433papgl.f[2]++;
        cov_w433papgl.s[6]++;
        this.changedByExpand = false;
      }
    }, {
      key: "getTreeIndent",
      value: function getTreeIndent() {
        cov_w433papgl.f[3]++;

        var _ref = (cov_w433papgl.s[7]++, this.props),
            columns = _ref.columns;

        cov_w433papgl.s[8]++;

        for (var i = 0; i < columns.length; i++) {
          cov_w433papgl.s[9]++;

          if (typeof columns[i].treeIndent === 'number') {
            cov_w433papgl.b[0][0]++;
            cov_w433papgl.s[10]++;
            return columns[i].treeIndent;
          } else {
            cov_w433papgl.b[0][1]++;
          }
        }

        cov_w433papgl.s[11]++;
        return TREE_TABLE_DEFAULT_INDENT;
      }
    }, {
      key: "getExpandKeys",
      value: function getExpandKeys() {
        cov_w433papgl.f[4]++;

        var _ref2 = (cov_w433papgl.s[12]++, this.props),
            treeExpandKeys = _ref2.treeExpandKeys;

        cov_w433papgl.s[13]++;

        if (!treeExpandKeys) {
          cov_w433papgl.b[1][0]++;
          cov_w433papgl.s[14]++;
          return this.state.expandKeys;
        } else {
          cov_w433papgl.b[1][1]++;
        }

        cov_w433papgl.s[15]++;
        return TreeExpand.getMapFromArray(treeExpandKeys);
      }
    }, {
      key: "getExpandData",
      // getChildrenLength(children) {
      //   const { treeColumnsName, keygen } = this.props
      //   const { expandKeys } = this.state
      //   if (!children) return 0
      //   let { length = 0 } = children
      //   for (let i = 0; i < children.length; i++) {
      //     const child = children[i]
      //     const key = getKey(child, keygen)
      //     if (!expandKeys.get(key)) continue
      //     expandKeys.delete(key)
      //     if (child[treeColumnsName] && child[treeColumnsName].length) {
      //       length += this.getChildrenLength(child[treeColumnsName])
      //     }
      //   }
      //   return length
      // }
      value: function getExpandData() {
        var _this2 = this;

        cov_w433papgl.f[7]++;

        var _ref3 = (cov_w433papgl.s[19]++, this.props),
            data = _ref3.data,
            keygen = _ref3.keygen,
            treeColumnsName = _ref3.treeColumnsName;

        var expandKeys = (cov_w433papgl.s[20]++, this.getExpandKeys());
        cov_w433papgl.s[21]++;
        this.expandLevel = new Map();
        cov_w433papgl.s[22]++;

        if (expandKeys.size === 0) {
          cov_w433papgl.b[2][0]++;
          cov_w433papgl.s[23]++;
          return data;
        } else {
          cov_w433papgl.b[2][1]++;
        }

        var storeExpandKeys = (cov_w433papgl.s[24]++, new Map());
        cov_w433papgl.s[25]++;
        expandKeys.forEach(function (value, key) {
          cov_w433papgl.f[8]++;
          cov_w433papgl.s[26]++;
          return storeExpandKeys.set(key, value);
        });
        var cloneData = (cov_w433papgl.s[27]++, JSON.parse(JSON.stringify(data)));
        cov_w433papgl.s[28]++;
        return immer(cloneData, function (draft) {
          cov_w433papgl.f[9]++;
          var dataCo = (cov_w433papgl.s[29]++, draft);
          cov_w433papgl.s[30]++;

          var _loop = function _loop(i) {
            cov_w433papgl.s[31]++;

            if (storeExpandKeys.size === 0) {
              cov_w433papgl.b[3][0]++;
              cov_w433papgl.s[32]++;
              return "break";
            } else {
              cov_w433papgl.b[3][1]++;
            }

            var item = (cov_w433papgl.s[33]++, dataCo[i]);
            var key = (cov_w433papgl.s[34]++, getKey(item, keygen, i));
            var parentLevel = (cov_w433papgl.s[35]++, (cov_w433papgl.b[4][0]++, _this2.expandLevel.get(key)) || (cov_w433papgl.b[4][1]++, 0));
            var children = (cov_w433papgl.s[36]++, item[treeColumnsName]);
            cov_w433papgl.s[37]++;

            if ((cov_w433papgl.b[6][0]++, storeExpandKeys.get(key)) && (cov_w433papgl.b[6][1]++, children)) {
              cov_w433papgl.b[5][0]++;
              cov_w433papgl.s[38]++;
              children.forEach(function (child) {
                cov_w433papgl.f[10]++;
                cov_w433papgl.s[39]++;

                _this2.expandLevel.set(getKey(child, keygen), parentLevel + 1);
              });
              cov_w433papgl.s[40]++;
              draft.splice.apply(draft, [i + 1, 0].concat(_toConsumableArray(children)));
              cov_w433papgl.s[41]++;
              dataCo = draft;
              cov_w433papgl.s[42]++;
              storeExpandKeys["delete"](key);
            } else {
              cov_w433papgl.b[5][1]++;
            }
          };

          for (var i = 0; i < dataCo.length; i++) {
            var _ret = _loop(i);

            if (_ret === "break") break;
          }
        });
      }
    }, {
      key: "handleTreeExpand",
      value: function handleTreeExpand(data, index) {
        cov_w433papgl.f[11]++;

        var _ref4 = (cov_w433papgl.s[43]++, this.props),
            keygen = _ref4.keygen,
            treeExpandKeys = _ref4.treeExpandKeys,
            onTreeExpand = _ref4.onTreeExpand;

        var expandKeys = (cov_w433papgl.s[44]++, this.getExpandKeys());
        var key = (cov_w433papgl.s[45]++, getKey(data, keygen, index));
        var changedKeys = (cov_w433papgl.s[46]++, immer(expandKeys, function (draft) {
          cov_w433papgl.f[12]++;
          cov_w433papgl.s[47]++;
          // eslint-disable-next-line no-unused-expressions
          expandKeys.get(key) ? (cov_w433papgl.b[7][0]++, draft["delete"](key)) : (cov_w433papgl.b[7][1]++, draft.set(key, true));
        }));
        cov_w433papgl.s[48]++;

        if ((cov_w433papgl.b[9][0]++, treeExpandKeys) && (cov_w433papgl.b[9][1]++, onTreeExpand)) {
          cov_w433papgl.b[8][0]++;
          cov_w433papgl.s[49]++;
          onTreeExpand(keysToArray(changedKeys), data, !!expandKeys.get(key), index);
          cov_w433papgl.s[50]++;
          return;
        } else {
          cov_w433papgl.b[8][1]++;
        }

        cov_w433papgl.s[51]++;
        this.changedByExpand = true;
        cov_w433papgl.s[52]++;
        this.setState({
          expandKeys: changedKeys
        });
      }
    }, {
      key: "render",
      value: function render() {
        cov_w433papgl.f[13]++;

        var _ref5 = (cov_w433papgl.s[53]++, this.props),
            treeColumnsName = _ref5.treeColumnsName;

        var expandKeys = (cov_w433papgl.s[54]++, this.getExpandKeys());
        var data = (cov_w433papgl.s[55]++, this.getExpandData());
        var rootTree = (cov_w433papgl.s[56]++, data.filter(function (v) {
          cov_w433papgl.f[14]++;
          cov_w433papgl.s[57]++;
          return (cov_w433papgl.b[10][0]++, v) && (cov_w433papgl.b[10][1]++, v[treeColumnsName]) && (cov_w433papgl.b[10][2]++, v[treeColumnsName].length);
        }).length === 0);
        var treeIndent = (cov_w433papgl.s[58]++, this.getTreeIndent());
        cov_w433papgl.s[59]++;
        return (
          /*#__PURE__*/
          React.createElement(WrappedComponent, Object.assign({}, this.props, {
            changedByExpand: (cov_w433papgl.b[11][0]++, this.changedByExpand) || (cov_w433papgl.b[11][1]++, this.props.changedByExpand),
            data: data,
            onTreeExpand: this.handleTreeExpand,
            treeExpandKeys: expandKeys,
            treeExpandLevel: this.expandLevel,
            treeRoot: rootTree,
            treeIndent: treeIndent,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 132,
              columnNumber: 9
            }
          }))
        );
      }
    }], [{
      key: "getMapFromArray",
      value: function getMapFromArray(arr) {
        cov_w433papgl.f[5]++;
        cov_w433papgl.s[16]++;
        return arr.reduce(function (map, key) {
          cov_w433papgl.f[6]++;
          cov_w433papgl.s[17]++;
          map.set(key, true);
          cov_w433papgl.s[18]++;
          return map;
        }, new Map());
      }
    }]);

    return TreeExpand;
  }(React.Component), _class.defaultProps = defaultProps, _temp;
});